import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_BASE || 'https://dendros-wompi.azurewebsites.net'

// Cliente del backend Amatea (dendros-wompi)
export const HTTP = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Compat con el código existente que hacía `config.server.concat(...)`
export default {
  server: API_BASE,
}
